<script>
import { FormModel } from '@/components/global/form';
import { scrollToError } from '../../utilities/helpers';

export default {
    name: 'CcPlansInfoFrom',

    props: {
        initialData: null,
    },

    data() {
        return {
            loading: false,
            model: null,
            additionalIndex: -1,
        };
    },

    created() {
        this.model = new FormModel(this.initialData);
    },

    watch: {
        'model.$.no_other_bank_accounts'(value) {
            if (value) {
                this.model.$.other_bank_accounts = [];
            }
        },
    },

    methods: {
        async submit() {
            if (this.loading) {
                return;
            }
            this.loading = true;

            try {
                const response = await this.$http.post('/registracija/informacija-apie-planus', this.model.$);
                window.location = response.data.data.redirect;
            } catch (e) {
                this.model.$e.updateFromResponse(e);
                scrollToError();
                this.$sentyReporting.report(e);
            }

            this.loading = false;
        },

        addOtherBankAccount() {
            this.model.$.other_bank_accounts.push({ id: this.additionalIndex--, title: '', country: '', country_id: null });
        },

        removeOtherBankAccount(relation) {
            this.model.$.other_bank_accounts = this.model.$.other_bank_accounts.filter(item => item !== relation);
        },

        addCountryOfTransaction() {
            this.model.$.countries_of_transaction.push({ id: this.additionalIndex--, country: '' });
        },

        removeCountryOfTransaction(relation) {
            this.model.$.countries_of_transaction = this.model.$.countries_of_transaction.filter(item => item !== relation);
        },
    },
};
</script>
